import { render, staticRenderFns } from "./model-filter-v4.vue?vue&type=template&id=af3dfb02&scoped=true&"
import script from "./model-filter-v4.vue?vue&type=script&lang=js&"
export * from "./model-filter-v4.vue?vue&type=script&lang=js&"
import style0 from "./model-filter-v4.vue?vue&type=style&index=0&id=af3dfb02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3dfb02",
  null
  
)

export default component.exports